<template>
	<div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<el-container>
			<el-header :style="'background-color:' + nowTheme">
				<div class="flex">
					<div class="logo flex" @click="homeIndex" style="cursor: pointer;">
						<img src="../../assets/logo.png" alt="" height="60px" />
						<h4 style="display: inline-block;">{{ appName ? appName : '请输入网站名称' }}</h4>
					</div>
					<div class="flex">
						<template v-if="!userInfo.id">
							<div>您好，</div>
							<div @click="login">请登录</div>
						</template>
						<template v-else>
							<div>欢迎您，</div>
							<div>
								<el-menu
									:background-color="nowTheme"
									text-color="#fff"
									active-text-color="#ffd04b"
									unique-opened
									menu-trigger="hover"
									mode="horizontal"
									class="title-menu"
								>
									<el-submenu index="1">
										<template slot="title">
											{{ userInfo.nickname }}
										</template>
										<el-menu-item @click="toPage('/userManage')" index="1-1">个人中心</el-menu-item>
										<el-menu-item @click="changePassword" index="1-2">修改密码</el-menu-item>
										<el-menu-item @click="logout" index="1-3">退出登录</el-menu-item>
									</el-submenu>
									<el-menu-item @click="toPage('/cart')">
										<el-badge :value="userInfo.cart_num" class="badge">
											<span style="padding: 0 10px;">
												<i class="el-icon-shopping-cart-1"></i>
												购物车
											</span>
										</el-badge>
									</el-menu-item>
								</el-menu>
							</div>
						</template>
					</div>
				</div>
			</el-header>
			<el-main style="min-height: 100vh;">
				<keep-alive include="home"><router-view @showLoading="showLoading"></router-view></keep-alive>
			</el-main>
		</el-container>

		<el-dialog title="修改密码" :visible.sync="dialogVisible" :before-close="dialogClose">
			<el-form :model="pswdForm" status-icon :rules="rules" ref="pswdForm" label-width="80px" class="demo-pswdForm" style="max-width: 500px;margin:30px auto;">
				<el-form-item label="原始密码" prop="oldpswd"><el-input type="text" v-model="pswdForm.oldpswd" autocomplete="off"></el-input></el-form-item>
				<el-form-item label="新密码" prop="newpswd"><el-input type="password" v-model="pswdForm.newpswd" autocomplete="off"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">取 消</el-button>
				<el-button type="primary" @click="submitForm('pswdForm')">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 滚动到顶部组件 -->
		<el-backtop></el-backtop>
	</div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
	data() {
		var checkUser = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请输入原始密码'));
			} else {
				callback();
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入新密码'));
			} else {
				if (this.pswdForm.checkPass !== '') {
					this.$refs.pswdForm.validateField('checkPass');
				}
				callback();
			}
		};
		return {
			loading: false,
			dialogVisible: false,
			themeDialogVisible: false,
			themeColor: '#141C23',
			pswdForm: {
				oldpswd: '',
				newpswd: ''
			},
			rules: {
				newpswd: [
					{
						validator: validatePass,
						trigger: 'blur'
					}
				],
				oldpswd: [
					{
						validator: checkUser,
						trigger: 'blur'
					}
				]
			},
			paths: [],
			paths_loaded: false,
		};
	},
	methods: {
		...mapActions({
			exit: 'auth/logout',
			changePswd: 'auth/changePassword',
			setTheme: 'theme/setTheme'
		}),
		...mapMutations({
			setAppName: 'auth/setAppName',
			setHost: 'auth/setHost'
		}),
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		dialogClose(done) {
			done();
			// this.$confirm('确认关闭？')
			//  .then(_ => {
			//    done();
			//  })
			//  .catch(_ => {});
		},
		themeDialogClose(done) {
			done();
		},
		logout() {
			this.exit().then(res => {
				console.log(res);
				if (res.actionStatus == 1) {
					this.$router.push('/home');
				}
			});
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.openFullScreen1();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		changePassword() {
			this.dialogVisible = true;
		},
		closeDialog() {
			this.dialogVisible = false;
			this.resetForm('pswdForm');
		},
		closeThemeDialog() {
			this.themeDialogVisible = false;
		},
		changeTheme() {
			this.themeDialogVisible = true;
		},
		changeThemeColor(e) {
			console.log(e);
		},
		changeThemeConfirm() {
			this.setTheme(this.themeColor).then(res => {
				this.themeDialogVisible = false;
			});
		},
		openFullScreen1() {
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(255, 255, 255, 0.4)'
			});
			setTimeout(() => {
				let url = this.HOST;
				this.changePswd({
					url,
					data: this.pswdForm
				}).then(res => {
					console.log(res);
					if (res.status == 1) {
						loading.close();
						this.dialogVisible = false;
						this.$router.push('/login');
					}
				});
			}, 2000);
		},
		showLoading(e) {
			console.log('loading', e);
			this.loading = e;
		},
		login() {
			this.$router.push('/login');
		},
		toPage(path) {
			this.$router.push(path);
		}
	},
	computed: {
		...mapState({
			navList: state => state.navBar.navList,
			userInfo: state => JSON.parse(state.user.userInfo)
		}),
		routepath() {
			console.log('path', this.$route.path);
			var name = this.$route.name;
			if (name) {
				for (let i in this.navList) {
					if (name == this.navList[i].path) {
						name = this.navList[i].path;
						return;
					}
				}
			} else {
				name = this.$route.path;
			}
			return name;
		},
		nowTheme() {
			console.log('.....:', this.$store.state.navBar.navList);
			return this.$store.state.theme.defaultTheme;
		},
		appName() {
			console.log(this.$store.state.auth.appName);
			return this.$store.state.auth.appName;
		}
	},
	mounted() {
		this.setHost(this.HOST);
		console.log(this.userInfo);
	}
};
</script>

<style lang="scss">
.el-header {
	height: auto !important;
}
.el-main{
	background-color: #f0f3ef;
	padding: 0;
	>div{
		background-color: #fff !important;
	}
	.header {
		background-color: #fff;
		padding: 20px;
		margin: 0;
	}
	.container{
		padding: 0 15px;
	}
}
.flex {
	display: flex;
	justify-content: space-between;
}
.flex-start {
	display: flex;
	justify-content: flex-start;
}
.el-menu {
	border-right: 0 !important;
}
.el-menu-item.is-active {
	border: none !important;
}
@media screen and (max-width: 768px) {
	.el-dialog {
		width: 80% !important;
	}
}
.title-menu::before,
.title-menu::after {
	display: inline;
}
.badge {
	display: inline;
}
</style>
